import axios from "axios";

//Set default header for POST requests to application/x-www-form-urlencoded
//This is so PHP backends properly place data into $_POST array.
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

//Create an axios instance with a base URL and timeout.
export default axios.create({
    baseURL: "/api",
    timeout: 10000
});